export default {
  desktop: '512px',
  small: '321px',
};



// WEBPACK FOOTER //
// ./src/components/SurveyToast/styles/constants/BreakPoint.js